import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { z } from 'zod';
import http from '@/utils/http.service';

const setAccountingInformationResponseSchema = z.object({
  workAtTheSameTime: z.object({
    morning: z.coerce.number(),
    afternoon: z.coerce.number(),
    night: z.coerce.number(),
  }),
  isFeeApplicable: z.coerce.boolean().nullable(),
});

export type SetAccountingInformationResponse = z.infer<
  typeof setAccountingInformationResponseSchema
>;

const setAccountingInformation = (id: string) => {
  return http.agendaSlots
    .setAccountingInformation(id)
    .then<SetAccountingInformationResponse>((response) => {
      return response.data;
    });
};

export const useAgendaSlotSetAccountingInformation = (): UseMutationResult<
  SetAccountingInformationResponse,
  Error,
  string
> => {
  const { t } = useTranslation();
  return useMutation({
    mutationFn: setAccountingInformation,
    onSuccess() {
      toast.success(t('http.agenda-slot-set-accounting-information.success'));
    },
  });
};
